import React from 'react';
import { useState, useEffect } from 'react';
import SelectInput from './SelectInput';
import { getUniversities } from '@services/universityService';


const UniversitySelectInput = ({ register, errors, name, validationRules = { required: 'University is required' }, withOtheroption = false }) => {
  const [universityOptions, setUniversityOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUniversities = async () => {
      try {
        const data = await getUniversities();
        const options = [
          ...data.map(({ id, name }) => ({ value: id, label: name })),
          ...(withOtheroption ? [{ value: 'other', label: 'Other' }] : [])
        ];
        setUniversityOptions(options);
      } catch (error) {
        console.error('Error fetching universities:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUniversities();
  }, []);

  if (loading) {
    return <p>Loading universities...</p>;
  }

  return (
    <SelectInput
      label="University"
      name={name}
      register={register}
      errors={errors}
      options={universityOptions}
      validationRules={validationRules}
    />
  );
};

export default UniversitySelectInput;